import { AnalyticsTracker } from './AnalyticsTracker';
import { MarketingOptimizationTracking } from './trackingModules/MarketingOptimizationTracking';
import type { Platform } from '../platform/Platform';
import type { TrackingModule } from './types';
import type { AppStateController } from '../state/AppStateController';

export function getTrackingModule(
  platform: Platform,
  stateController: AppStateController,
): TrackingModule {
  const tracking = new AnalyticsTracker();
  const factory = platform.getTrackingModuleFactory();
  if (factory) {
    tracking.addModule(factory({ stateController }));
    tracking.addModule(new MarketingOptimizationTracking(platform));
  }

  return tracking;
}
